import React from 'react';
import { useEvaluationCriteriaDialog } from '@/contexts/EvaluationCriteriaDialogContext';
import { useBrandManager } from '@/contexts/BrandProvider';
import { useEvaluationCategories } from '@/hooks/useEvaluationCategories';
import { useEvaluationCriteria } from '@/hooks/useEvaluationCriteria';
import { useEmployeePositions } from '@/hooks/useEmployeePositions';
import { EvaluationCriteriaDialog } from './EvaluationCriteriaDialog';

export const GlobalEvaluationCriteriaDialog: React.FC = () => {
  const { isOpen, editingCriteria, closeCriteriaDialog } = useEvaluationCriteriaDialog();
  const { currentBrandId } = useBrandManager();
  const { categories } = useEvaluationCategories(currentBrandId);
  const { createCriteria, updateCriteria } = useEvaluationCriteria(currentBrandId);
  const { positions } = useEmployeePositions(currentBrandId);

  const handleSave = async (data: any) => {
    if (editingCriteria) {
      await updateCriteria(editingCriteria.id, data);
    } else {
      await createCriteria(data);
    }
    closeCriteriaDialog();
  };

  return (
    <EvaluationCriteriaDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) closeCriteriaDialog();
      }}
      criteria={editingCriteria}
      categories={categories}
      positions={positions}
      onSave={handleSave}
    />
  );
};
